import { render, staticRenderFns } from "./ProductionPopForm.vue?vue&type=template&id=2c73ccf2"
import script from "./ProductionPopForm.vue?vue&type=script&lang=js"
export * from "./ProductionPopForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports